import axios from 'axios';

const configured = (process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api').replace(/\/+$/, '');
const baseUrl = configured.endsWith('/api') ? configured : `${configured}/api`;

export const getPressSourceUrl = (value) => {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : null;
  } catch {
    return null;
  }
};

export const getPressImageUrl = (value) => {
  if (!value || !value.startsWith('/BasinResimleri/')) return null;
  return `https://iskenderun.bel.tr${value}`;
};

export const getPressCoverage = async (params, signal) => {
  const response = await axios.get(`${baseUrl}/press-coverage`, { params, signal });
  if (!response.data?.isSuccess) throw new Error(response.data?.resultMessage || 'Basında Biz içerikleri yüklenemedi.');
  return response.data.data;
};
